module.exports = __webpack_public_path__ + "static/dm_automations-b1ed6ce549cbc23979d8934567e5e43b.webp";